import React, { useState } from "react"
import Swiper from "react-id-swiper"
import "swiper/dist/css/swiper.min.css"

interface SlideshowProps {
  options?: Object
  children: JSX.Element[]
  className?: string
}

const Slideshow: React.FC<SlideshowProps> = ({
  options, children, className
}) => {
  const [ swiper, setSwiper ] = useState(null)

  const next = () => {
    if(swiper !== null) swiper.slideNext()
  }
  const prev = () => {
    if(swiper !== null) swiper.slidePrev()
  }

  return (
    <div className={`relative w-full ${className ? className : ''}`}>
      <Swiper
        getSwiper={setSwiper}
        {...options}
      >
        {React.Children.map(children, (slide) => (
          React.cloneElement(slide as JSX.Element)
        ))}
      </Swiper>

      <button
        onClick={prev}
        className="absolute z-10 px-2 py-4 pin left-0 text-white hover:text-pink-500"
        style={{
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0, 0, 0, 0.66)"
        }}
      >
        &larr;
      </button>

      <button
        onClick={next}
        className="absolute z-10 px-2 py-4 right-0 text-white hover:text-pink-500"
        style={{
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0, 0, 0, 0.66)"
        }}
      >
        &rarr;
      </button>
    </div>
  )
}

export default Slideshow
